module.exports = __webpack_public_path__ + "img/support2.433492dd.svg";